export default __webpack_public_path__ + "static/media/shopifyConcentPage.5459e6dc.svg";